import { render, staticRenderFns } from "./ocrTestFile.vue?vue&type=template&id=0739bba5&"
import script from "./ocrTestFile.vue?vue&type=script&lang=js&"
export * from "./ocrTestFile.vue?vue&type=script&lang=js&"
import style0 from "./ocrTestFile.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0739bba5')) {
      api.createRecord('0739bba5', component.options)
    } else {
      api.reload('0739bba5', component.options)
    }
    module.hot.accept("./ocrTestFile.vue?vue&type=template&id=0739bba5&", function () {
      api.rerender('0739bba5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SystemMaintenance/components/ocr/ocrTestFile.vue"
export default component.exports